(ns frontend.ui.component.image-cropper.view
  (:require
   [ui.components.button.view :as button]
   [frontend.ui.component.file-input.view :refer [file-input]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.image-cropper.core :as core]
   [frontend.ui.component.image-cropper.util :as util]
   [frontend.ui.component.modal-dialog.core :as modal-dialog-core]
   [frontend.ui.component.modal-dialog.view :refer [modal-dialog]]
   [herb.core :refer [<class]]
   ["react-easy-crop" :default Cropper]
   [reagent.core :as r]
   [frontend.ui.component.image-cropper.style :as style]))

(defn image-cropper
  "Bare controlled component allowing user to crop/zoom an image.

  Note that this component only tracks crop/zoom parameters and renders them in
  its UI as user interacts with the it. The actual cropping of the file needs
  to happen in a parent component. See `modal-image-cropper` for a component
  that also performs the cropping on the file."
  [{:keys [state
           on-crop-change
           set-cropping
           on-zoom-change
           min-zoom
           target-width
           target-height
           round?]}
   file]
  [grid/container {:breakpoint :fluid}
   [:div
    {:style {:display         "flex"
             :align-items     "center"
             :justify-content "center"}}
    [:div
     {:class (<class style/react-cropper)}
     [:> Cropper
      {:image             file
       :crop              (:crop state)
       :on-crop-change    on-crop-change
       :on-crop-complete  set-cropping
       :zoom              (:zoom state)
       :min-zoom          (or min-zoom 0.5)
       :max-zoom          5
       :on-zoom-change    on-zoom-change
       :restrict-position false
       :show-grid         false
       :crop-shape        (if round? "round" "rect")
       :aspect            (/ target-width target-height)}]]]
   [:div
    {:style {:display         "flex"
             :align-items     "center"
             :justify-content "center"
             :padding         "16px 0"}}
    ;; TODO extract this "range input" into its own component
   [:input
     {:type  "range"
      :min   (or min-zoom 0.5)
      :max   5
      :step  0.05
      :value (:zoom state)
      :on-change on-zoom-change}]]])

(defn- crop-and-close-modal
  [{:keys [target-width target-height on-cropped ]}
   {:keys [hide!]}
   image-cropper-state
   file]
  (let [{:keys [pixels]} (js->clj image-cropper-state :keywordize-keys true)]
    (on-cropped (util/crop-image file pixels target-width target-height))
    (hide!)))

(defn modal-image-cropper
  "Image cropping UI component (in a modal) that also handles cropping of the underlying state file"
  [_initial-props]
  (let [{:keys [show atom-visible?] :as modal-props} (modal-dialog-core/init-props)
        file-atom            (r/atom nil)
        show-image-cropper   (fn [e]
                               (util/read-file! file-atom e)
                               (show))
        image-cropper-props  (core/init-props)]
    (fn [{:keys [input-id size target-width target-height round? _on-cropped] :as props}]
      [:div
       [file-input
        {:input-id        (or input-id :image-default)
         :handle-add-file show-image-cropper
         :images-only?    true
         :file-types      [".png" ".jpg" ".jpeg" ".svg"]}]

       (when-let [file @file-atom]
         [modal-dialog
          (assoc modal-props
                 :visible?     @atom-visible?
                 :header-label "Crop file"
                 :size         size)

          [image-cropper
           (-> image-cropper-props
               (update :state deref)
               (merge {:target-width  target-width
                       :target-height target-height
                       :min-zoom      (:min-zoom props)
                       :round?        round?}))
           file]

          [button/primary-solid
           {:on-click (fn [_e]
                        (crop-and-close-modal
                         props
                         modal-props
                         @(:state image-cropper-props)
                         @file-atom))}
           "Done"]])])))
